<template>
  <v-dialog
    v-model="visible"
    max-width="520"
    scrollable
  >
    <v-card v-if="rooms.length" :color="cardColor" dark>
      <v-card-title class="d-flex align-center">
        <v-icon left>mdi-broom</v-icon>
        <span v-if="rooms.length === 1">Reinigung: {{ rooms[0].name }}</span>
        <span v-else>Reinigung: {{ rooms.length }} Räume</span>
        <v-spacer />
        <v-btn icon @click="cancel"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <div class="mb-4 d-flex flex-wrap align-center">
          <v-chip
            v-for="r in rooms"
            :key="r.segment_id"
            :color="segmentColor(r.segment_id)"
            small
            label
            dark
            class="ma-1"
            :close="rooms.length > 1"
            @click:close="$emit('remove-room', r.segment_id)"
          >{{ r.name }}</v-chip>
          <v-chip
            small
            label
            outlined
            class="ma-1"
            @click="$emit('add-room')"
          >
            <v-icon left small>mdi-plus</v-icon>Raum auf Karte
          </v-chip>
        </div>

        <div class="overline mb-1">Saugkraft</div>
        <v-btn-toggle v-model="form.fan_power" mandatory dense color="primary" class="mb-3 d-flex flex-wrap">
          <v-btn v-for="o in fanLevels" :key="o.value" :value="o.value" small>
            <v-icon left small>{{ o.icon }}</v-icon>{{ o.label }}
          </v-btn>
        </v-btn-toggle>

        <div class="overline mb-1">Wasser</div>
        <v-btn-toggle v-model="form.water_box_mode" mandatory dense color="primary" class="mb-3 d-flex flex-wrap">
          <v-btn v-for="o in waterModes" :key="o.value" :value="o.value" small>
            <v-icon left small>{{ o.icon }}</v-icon>{{ o.label }}
          </v-btn>
        </v-btn-toggle>

        <div class="overline mb-1">Wisch-Pattern</div>
        <v-btn-toggle v-model="form.mop_mode" mandatory dense color="primary" class="mb-3 d-flex flex-wrap" :disabled="form.water_box_mode === 200">
          <v-btn v-for="o in mopModes" :key="o.value" :value="o.value" small>{{ o.label }}</v-btn>
        </v-btn-toggle>

        <div class="overline mb-1">Durchgänge</div>
        <v-btn-toggle v-model="form.repeat" mandatory dense color="primary">
          <v-btn :value="1" small>1×</v-btn>
          <v-btn :value="2" small>2×</v-btn>
          <v-btn :value="3" small>3×</v-btn>
        </v-btn-toggle>

        <v-alert v-if="error" type="error" class="mt-4 mb-0" dense>{{ error }}</v-alert>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn text @click="cancel">Abbrechen</v-btn>
        <v-spacer />
        <v-btn color="primary" :loading="loading" @click="submit">
          <v-icon left>mdi-play</v-icon>Reinigung starten
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { vacuumApi, FAN_LEVELS, WATER_MODES, MOP_MODES } from '@/services/vacuum'
import { segmentColor } from '@/services/rrMap'

export default {
  name: 'CleanRoomDialog',
  props: {
    value: Boolean,
    rooms: { type: Array, default: () => [] },
  },
  data: () => ({
    fanLevels: FAN_LEVELS,
    waterModes: WATER_MODES,
    mopModes: MOP_MODES,
    form: {
      fan_power: 102,
      water_box_mode: 200,
      mop_mode: 300,
      repeat: 1,
    },
    loading: false,
    error: '',
  }),
  computed: {
    visible: {
      get() { return this.value },
      set(v) { this.$emit('input', v) },
    },
    cardColor() {
      // Bei genau einem Raum dessen Segment-Farbe, sonst neutrales Dunkel.
      return this.rooms.length === 1 ? segmentColor(this.rooms[0].segment_id) + 'DD' : '#222'
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.error = ''
        // Wischen ist immer per Default aus — wer wischen will, wählt aktiv eine Wischstärke.
        this.form.water_box_mode = 200
      }
    },
  },
  methods: {
    segmentColor,
    cancel() {
      this.visible = false
    },
    async submit() {
      if (!this.rooms.length) return
      this.loading = true
      this.error = ''
      try {
        await vacuumApi.cleanRooms({
          segments: this.rooms.map(r => r.segment_id),
          repeat: this.form.repeat,
          fan_power: this.form.fan_power,
          water_box_mode: this.form.water_box_mode,
          mop_mode: this.form.mop_mode,
        })
        this.$emit('started', this.rooms)
        this.visible = false
      } catch (e) {
        this.error = (e && e.message) || 'Reinigung konnte nicht gestartet werden'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
